import moment from 'moment';
import {
  REFERRAL_SERVICE_CREATE_REQUEST,
  REFERRAL_SERVICE_CREATE_SUCCESS,
  REFERRAL_SERVICE_CREATE_FAILURE,
} from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';

export function createReferralService(refferalServiceData) {
  return {
    types: [REFERRAL_SERVICE_CREATE_REQUEST, REFERRAL_SERVICE_CREATE_SUCCESS, REFERRAL_SERVICE_CREATE_FAILURE],
    buildCallParameters: () => ({
      method: HTTP_METHOD.POST,
      data: {
        Name: refferalServiceData.name,
        ServiceId: refferalServiceData.serviceId,
        EndDate: refferalServiceData.endDate
          ? moment(refferalServiceData.endDate).utcOffset(0, true)
          : moment(new Date(9999, 11, 31, 0, 0, 0, 0)).utcOffset(0, true),
      },
      path: 'v1/command/CreateReferralService',
    }),
  };
}
